module.exports = __webpack_public_path__ + "static/cassandra-a17b51b2c93f6a4457bb4276313db707.png";